import React from 'react';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { InputTextarea } from 'primereact/inputtextarea';

/**
 * Shared "confirm with an optional/required comment" dialog for the CVRF form.
 * Previously FormVehicleRegistrationForm.jsx repeated this exact structure three
 * times (send-for-approval, return, approve), each with its own copy of the
 * header/message/textarea/accept/reject wiring.
 */
const CVRFCommentConfirmDialog = ({ visible, onHide, header, promptText, value, onChange, required = false, placeholder, accept, reject, acceptLabel, rejectLabel }) => (
    <ConfirmDialog
        visible={visible}
        onHide={onHide}
        header={header}
        style={{ width: '25vw' }}
        message={
            <div style={{ width: '100%' }}>
                <p style={{ width: '20vw' }}>{promptText}</p>
                <InputTextarea rows={3} value={value} onChange={onChange} className={required && !value ? 'p-invalid w-full' : 'w-full'} placeholder={placeholder} />
            </div>
        }
        accept={accept}
        reject={reject}
        acceptLabel={acceptLabel}
        rejectLabel={rejectLabel}
    />
);

export default CVRFCommentConfirmDialog;
